import type { StateCreator } from "../store";
import type { AppStore } from "../index";
import { stateServices } from "@/state/module_api";

export interface ProfilePhotoEntry {
  userId: string;
  /** Clean remote URL (.enc) stored on server; used only as metadata */
  url: string;
  /** Base64 display photo key, if available */
  keyBase64?: string;
  /** Local decrypted cache path (preferred for rendering) */
  cachePath?: string;
  /** Last update timestamp (ms) to allow retries/refresh */
  updatedAt?: number;
}

export interface ProfilePhotoSlice {
  profilePhotos: Record<string, ProfilePhotoEntry>;
  setProfilePhoto: (entry: ProfilePhotoEntry) => void;
  removeProfilePhoto: (userId: string) => void;
  clearProfilePhotos: () => void;
  getProfilePhoto: (userId: string) => ProfilePhotoEntry | undefined;
}

export const createProfilePhotoSlice: StateCreator<AppStore, unknown, unknown, ProfilePhotoSlice> = (set, get) => ({
  profilePhotos: {},

  setProfilePhoto: (entry) =>
    set((state) => {
      state.profilePhotos[entry.userId] = entry;
      if (entry.url) {
        stateServices.avatarCache.updatePhoto(entry.userId, entry.url);
      }
    }),

  removeProfilePhoto: (userId) =>
    set((state) => {
      delete state.profilePhotos[userId];
      stateServices.avatarCache.removePhoto(userId);
    }),

  clearProfilePhotos: () =>
    set((state) => {
      state.profilePhotos = {};
      stateServices.avatarCache.clear();
    }),

  getProfilePhoto: (userId) => get().profilePhotos[userId],
});
